var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-flex-col"},[_c('div',[_c('FormProject',{attrs:{"sit":_vm.sit,"format":_vm.format,"project":_vm.project},on:{"saved":function($event){return _vm.$emit('refresh')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }